<template>
  <div :style="{margin:gap}"><slot></slot></div>
</template>

<script>
export default {
  props: {
    gap: String
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?6e7b685c